export class GWCarRental {
    public id: number;
    public eventId: number;
    public startDate: string;
    public endDate: string;
    public provider: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-car-rental.model.ts